export default __webpack_public_path__ + "static/media/portfolio-90.d23bf035.jpg";